import MailCampaignList from './mail-campaign-list';

export default MailCampaignList;
